const initState = {
    input_channel: {
        channel_id: undefined,
        seller_id: undefined,
        auth_token: undefined,
    },
    verify_failure_visible: false,
    verify_success_visible: false,
    save_failure_visible: false,
    save_success_visible: false,
    connect_amazon_failure_visible: false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'ON_LOAD_CHANNEL':
            return { ...state, loading_verify: false, verify_success: false, input_channel: action.payload }

        case 'ON_CHANGE_CHANNEL':
            let copy = { ...state }
            let result = {
                loading_verify: copy.loading_verify,
                input_channel: {
                    ...copy.input_channel,
                    [action.payload.column]: action.payload.value,
                },
            }
            return result

        case 'ON_VERIFY':
            return { ...state, loading_verify: true }
        case 'ON_CONNECT_AMAZON_FAILURE':
            return {...state, connect_amazon_failure_visible: true}
        case 'ON_SAVE_CHANNEL':
            return { ...state, loading_save: true }
        case 'VERIFY_SUCCESS': {
            return { ...state, verify_success_visible: true, loading_verify: false, verify_success: true }
        }

        case 'VERIFY_FAILURE': {
            return { ...state, verify_failure_visible: true, loading_verify: false }
        }

        case 'SAVE_CHANNEL_SUCCESS': {
            return { ...state, save_success_visible: true, loading_save: false }
        }

        case 'SAVE_CHANNEL_FAILURE': {
            return { ...state, save_failure_visible: true, loading_save: false }
        }
        case 'ON_OK_CHANNEL': {
            return {
                ...state,
                verify_failure_visible: false,
                verify_success_visible: false,
                save_success_visible: false,
                save_failure_visible: false,
                connect_amazon_failure_visible: false,
            }
        }
        case 'ERROR_ECCHANNELS': {
            return {
                ...state,
                loading_save: false,
                loading_verify: false,
            }
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/settingChannelReducer.js